import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import { Paper } from 'material-ui';
import MapboxClient from 'mapbox';
import { fetchApp } from '../../../store/apps/actions';
import {
    getQuizzes, putQuiz,
} from '../../../store/quizzes/actions';
import withTranslation from '../../../hoc/withTranslation';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import styles from './EditQuizPage.css';
import style from '../../../styles/styles';
import Mapbox from '../../../components/openexplore/Mapbox/Mapbox';
import QuizForm from '../../../components/quiz/QuizForm/QuizForm';
import { QUIZ_PAGE } from '../../../constants/routes';

export class EditQuizPage extends React.Component {
    mapboxClient = new MapboxClient('pk.eyJ1IjoiZHJ1c3kiLCJhIjoiY2owYjBlNmhrMDAwdzJxcDloMnJybHd1NyJ9.H256nOJ0yauBFXMZJ9972A');

    static propTypes = {
        history: PropTypes.object,
        app: PropTypes.object,
        t: PropTypes.func,
        match: PropTypes.object,
        mapStyle: PropTypes.string,
        error: PropTypes.string,
        quizzes: PropTypes.object,
        currentLang: PropTypes.string,
        appPending: PropTypes.bool,
        quizzesPending: PropTypes.bool,
        quizzesSending: PropTypes.bool,
        loading: PropTypes.bool,
        fetchApp: PropTypes.func,
        getQuizzes: PropTypes.func,
    };

    state = {
        quiz: null,
        uploadingFiles: [],
        latlng: null,
        address: '',
        geolocationType: 'gps',
    };

    compareQuizId = (qu) => {
        return qu.id === this.props.match.params.quizId;
    };

    componentWillMount() {
        this.fetchApplication();
        if (this.props.quizzes[this.props.currentLang].length > 0) {
            let quiz = this.props.quizzes[this.props.currentLang].find(this.compareQuizId);
            this.setState({
                quiz: quiz,
                latlng: quiz && quiz.latitude && quiz.longitude
                    ? {
                        lat: quiz.latitude,
                        lng: quiz.longitude,
                        shouldCenter: true,
                    }
                    : null,
                geolocationType: quiz.geolocationType,
            });
        } else if (this.props.app && this.props.currentLang) {
            this.props.getQuizzes(this.props.app, this.props.currentLang);
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const lang = nextProps.currentLang;
        if ((
            this.props.match !== nextProps.match || !this.props.app
        ) && !nextProps.appPending) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (nextProps.app && !this.state.quiz && !nextProps.quizzesPending) {
            if (nextProps.quizzes[lang].length > 0) {
                const quiz = nextProps.quizzes[lang].find(function (qu) {
                    return qu.id === nextProps.match.params.quizId;
                });
                this.setState({
                    quiz: quiz,
                    latlng: quiz && quiz.latitude && quiz.longitude
                        ? {
                            lat: quiz.latitude,
                            lng: quiz.longitude,
                            shouldCenter: true
                        }
                        : null
                });
            } else {
                this.props.getQuizzes(nextProps.app, nextProps.currentLang);
            }
        }
        if (nextProps.quizzesQuestionSending === null && this.props.quizzesQuestionSending !== null) {
            const newQuiz = nextProps.quizzes[nextProps.currentLang].find(function (qu) {
                return qu.id === nextProps.match.params.quizId;
            });
            this.setState({
                quiz: newQuiz,
            });
        }
    }

    handleMapClicked = (event) => {

        if (this.state.geolocationType === 'gps') {
        this.setState({
            latlng: event.latlng,
        });
        this.mapboxClient.geocodeReverse(
            {
                latitude: event.latlng.lat,
                longitude: event.latlng.lng,
            })
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].place_name) {
                    this.setState({
                        address: res.entity.features[0].place_name,
                    });
                }
            })
            .catch(err => {
                //TODO: handle error
            });
        }
    };
    handleGeolocationTypeChange = (value) => {
        const newState = {
            ...this.state,
            geolocationType: value,
        };
        if (value === 'none') {
            newState.address = '';
            newState.latlng = null;

        }
        this.setState(newState);
    };
    handleLatChanged = (lat) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lat !== lat;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lat: Number.parseFloat(lat),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: Number.parseFloat(lat),
                lng: 0.0,
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleLngChanged = (lng) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lng !== lng;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: 0.0,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleAddressChanged = address => {
        this.setState({
            address: address,
        });
    };
    handleFormReset = () => {
        this.setState({
            uploadingFiles: [],
            latlng: this.state.quiz
            ? {
                lat: this.state.quiz.latitude,
                lng: this.state.quiz.longitude,
                shouldCenter: true,
            }
            : null,
            address: '',
        });
    };

    handleFindAddress = address => {

        this.mapboxClient.geocodeForward(address)
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].center
                    && res.entity.features[0].center.length === 2) {
                    const center = res.entity.features[0].center;
                    this.setState({
                        latlng: {
                            lat: Number.parseFloat(center[1]),
                            lng: Number.parseFloat(center[0]),
                            shouldCenter: true,
                        },
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.props.dispatchInfo('Could not geocode address: ' + address);
            });
    };

    handleFormSubmit = async (formProps) => {
        await this.props.putQuiz(this.props.app, formProps, this.props.currentLang)
            .then((newQuiz) => {
                this.props.history.push(
                    QUIZ_PAGE
                        .replace(':appId', this.props.app.id)
                        .replace(':quizId', newQuiz.id)
                );
            });
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>

                    <h3 style={style.navigation}>Quiz / Edit - {this.props.app.name}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper>
                                <Subheader style={style.subHeader}>
                                    Map
                                </Subheader>
                                <Mapbox
                                    latlng={this.state.latlng}
                                    onMapClicked={this.handleMapClicked}
                                    canShowDetail={false}
                                    showPopups={false}
                                    points={[]}
                                    trails={[]}
                                    style={styles.map}
                                    mapStyle={this.props.mapStyle}
                                />
                            </Paper>
                        </div>

                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.quiz.name')}
                                </Subheader>
                                <div style={style.paper}>
                                    <QuizForm
                                        onFormReset={this.handleFormReset}
                                        onLatChanged={this.handleLatChanged}
                                        onLngChanged={this.handleLngChanged}
                                        onFindAddress={this.handleFindAddress}
                                        onAddressChanged={this.handleAddressChanged}
                                        onGeolocationTypeChange={this.handleGeolocationTypeChange}
                                        latlng={this.state.latlng}
                                        address={this.state.address}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.quizzesSending}
                                        initialValues={{...this.state.quiz}}
                                        defaultGeolocationType={this.state.quiz.geolocation_type}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    let props = {
        mapStyle: state.ui.mapStyle,
        appPending: state.apps.pending,
        error: state.apps.error || state.quizzes.error,
        quizzesPending: state.quizzes.pending,
        quizzesSending: state.quizzes.sending,
        loading: state.apps.pending || state.quizzes.pending,
        quizzes: state.quizzes.content,
        currentLang: state.ui.currentLang,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    putQuiz,
    getQuizzes,
})(withRouter(withTranslation(EditQuizPage)));



// WEBPACK FOOTER //
// src/containers/quiz/EditQuizPage/EditQuizPage.js